export const PROVIDER_NAME = 'google';

/** The login page looks a key up here and never renders URL text, preventing phishing via query params. */
export const OAUTH_ERROR_MESSAGES = {
  DEFAULT: 'Authentication failed. Please try again.',
  DOMAIN_RESTRICTED: 'Only @feverup.com email addresses are allowed.',
  MISSING_INFO: 'Google account information was incomplete.',
} as const;

export type OAuthErrorKey = keyof typeof OAUTH_ERROR_MESSAGES;

const isOAuthErrorKey = (key: string): key is OAuthErrorKey => Object.hasOwn(OAUTH_ERROR_MESSAGES, key);

export const oauthErrorMessage = (key: string | null): string =>
  key !== null && isOAuthErrorKey(key) ? OAUTH_ERROR_MESSAGES[key] : OAUTH_ERROR_MESSAGES.DEFAULT;
